<i18n lang="yaml">
  ru:
    ActionSidebarSettingsQueryTitle: "Призыв к действию откроется, если выполнится"
    ActionSidebarSettingsQueryModeAny: "Любое из условий"
    ActionSidebarSettingsQueryModeEvery: "Каждое из условий"
  en:
    ActionSidebarSettingsQueryTitle: "The call to action will open if it is completed"
    ActionSidebarSettingsQueryModeAny: "Any of the conditions"
    ActionSidebarSettingsQueryModeEvery: "Every of the conditions"
</i18n>

<template>
  <PWAsideBodyItem>
    <template #header>
      <div :class="$style.actionSidebarSettingsQuery">
        {{ $t('ActionSidebarSettingsQueryTitle') }}
        <PWDropdown>
          <template #default="{ toggle }">
            <span
              :class="$style.actionSidebarSettingsQueryText"
              @click="toggle()"
            >
              {{ ' ' + currentQueryTitle }}
              <ArrowDropDownRounded :class="$style.actionSidebarSettingsQueryIcon" />
            </span>
          </template>
          <template #menu>
            <PWDropdownItem
              v-for="q in queryModes"
              :key="q"
              @click="valueLocal = q"
            >
              {{ q === 'any' ? $t('ActionSidebarSettingsQueryModeAny') : $t('ActionSidebarSettingsQueryModeEvery') }}
            </PWDropdownItem>
          </template>
        </PWDropdown>
      </div>
    </template>
  </PWAsideBodyItem>
</template>

<script>
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWDropdown from '@/components/_ui/Dropdowns/PWDropdown.vue'
import PWDropdownItem from '@/components/_ui/Dropdowns/PWDropdownItem.vue'
/**
 * Static
 */
import ArrowDropDownRounded from '@/assets/icons/ArrowDropDownRounded.svg?inline'

export default {
  components: {
    PWAsideBodyItem,
    ArrowDropDownRounded,
    PWDropdown,
    PWDropdownItem
  },
  props: {
    value: {
      type: String,
      default: 'any'
    }
  },
  data: () => ({
    queryModes: [
      'any',
      'every'
    ]
  }),
  computed: {
    valueLocal: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    currentQueryTitle () {
      return this.valueLocal === 'any'
        ? this.$t('ActionSidebarSettingsQueryModeAny').toLowerCase()
        : this.$t('ActionSidebarSettingsQueryModeEvery').toLowerCase()
    }
  }
}
</script>

<style module lang="scss">
.actionSidebarSettingsQuery {
  display: inline;
}

.actionSidebarSettingsQueryText {
  display: inline-flex;
  align-items: center;
  color: var(--main-blue);
  user-select: none;
  cursor: pointer;
}

.actionSidebarSettingsQueryIcon {
  --s: 24px;

  width: 24px;
  height: 24px;
}
</style>
